// extracted by mini-css-extract-plugin
export default {"confirmUpdatesStep":"confirmUpdatesStep-wvVd2","title":"title-KBxYe","contents":"contents-UCoVN","instrumentColumn":"instrumentColumn-M2LvI","dataTable":"dataTable-d8IeW"};